import ls from "./localStorage";

export function getUser() {
    return ls.getItem('user')
}

export function setUser(user, perms) {
    return ls.setItem('user', user)
}

export function getToken() {
    return ls.getItem('access_token')
}

export function getTokenExpiredAt() {
    return ls.getItem('access_token_expired_at')
}

export function setToken(tokenPayload) {
    const accessToken = tokenPayload.access_token
    const accessTokenExpiredAt = new Date().getTime() + tokenPayload.expires_in * 1000

    ls.setItem('access_token', accessToken)
    ls.setItem('access_token_expired_at', accessTokenExpiredAt)
}

export function logout() {
    return ls.clear()
}